export default __webpack_public_path__ + "static/media/sch3_w640.774ff22e.jpg";